import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Flex, Image, Text, Heading } from "@chakra-ui/react"

export default function TechnologyItem({ title, copy, image }) {
  return (
    <Flex
      flexDirection={{ base: "column", lg: "row" }}
      layerStyle="foreground"
      flex={1}
      bg="base.d100"
    >
      <Image
        image={image.childImageSharp.gatsbyImageData}
        maxH={{ base: "350px", lg: "350px", xl: "300px", xxl: "350px" }}
        maxW={{ base: "100% ", lg: "350px", xl: "300px", xxl: "350px" }}
        width="100%!important"
        position="relative"
        as={GatsbyImage}
        bg="white"
      />
      <Flex
        justifyContent={{ base: "flex-start", lg: "center" }}
        py={{ base: 6, lg: 0 }}
        flexDirection="column"
        flex={1}
        px={6}
      >
        <Heading fontSize="lg" fontWeight="medium" mb={4}>
          {title}
        </Heading>

        <Text>{copy}</Text>
      </Flex>
    </Flex>
  )
}
